import { render, staticRenderFns } from "./orgSchoolList.vue?vue&type=template&id=8c369054&scoped=true"
import script from "./orgSchoolList.vue?vue&type=script&lang=js"
export * from "./orgSchoolList.vue?vue&type=script&lang=js"
import style0 from "./orgSchoolList.vue?vue&type=style&index=0&id=8c369054&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c369054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c369054')) {
      api.createRecord('8c369054', component.options)
    } else {
      api.reload('8c369054', component.options)
    }
    module.hot.accept("./orgSchoolList.vue?vue&type=template&id=8c369054&scoped=true", function () {
      api.rerender('8c369054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/comps/orgSchoolList.vue"
export default component.exports